<template>
    <rkm-area
        no-margin-top
        title="Classificação de risco/Vulnerabilidade"
    >
        <rkm-row>
            <rkm-col cols="12">
                <Item :get-value="() => item.classificacaoRisco.nome" />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {
    components: {Item},
    props: {
        item: {type: Object, required: true},
    },
}
</script>